import { resetLikes } from './state.js'

import { getJSON, postJSON } from '../../src/lib/fetch'

import { translator, translations } from '../../bot/dist/bot.esm.js'

export class WebchatInterface {
  constructor({ bot, history }) {
    this.bot = bot
    this.history = history
    // Note: this code is probably unused
    // this.user = {
    //   update(data) {
    //     Object.assign(this, data)
    //   }
    // }
  }

  get __() {
    const translate = translator(translations)
    const { lang } = this.history.state()
    return key => translate(lang, key)
  }

  async send(message) {
    // Note: this was never used
    // if (typeof message === 'function') {
    //   message = await message({ state: this.history.state() })
    // }

    if (typeof message === 'string') {
      message = { text: message }
    }

    if (!message.text && !message.data && !message.next)
      return console.warn('no text', message)

    const { data } = message
    if (data) {
      for (const key in data) {
        if (
          ['occasion', 'gender', 'age', 'budget', 'categories'].includes(key)
        ) {
          // TODO: check if equal to state
          resetLikes()
        }
      }
    } else {
      message.data = {}
    }

    const ctx = {
      client: true,
      event: message,
      // user: this.user,
      postJSON: postJSON,
      getJSON: getJSON,
      reply(message) {
        this.outgoing = message
        // console.debug('webchat.send', this)
      }
    }
    // console.debug('incoming go bot', ctx)
    await this.bot(ctx)
    // console.debug('incoming after', ctx.outgoing)
    return ctx.outgoing
  }

  quick(index) {
    const last = this.history.items[this.history.items.length - 1]
    if (last && last.quick_replies && last.quick_replies[index]) {
      const qr = last.quick_replies[index]
      return this.send({
        text: qr.title,
        payload: qr.payload
      })
    }
  }

  async fetch(uri, options) {
    const r = await window.fetch(uri, options)
    return r.json()
  }
}
